<script>
  import Page from '@components/page'
  import { router } from '@inertiajs/svelte'
  import { LayoutDashboard, BookOpen, CirclePlay, FileText, Video, Users, Tags, Shield, UserCircle, MessageSquare, Receipt, ChevronRight, NotebookPen } from 'lucide-svelte'

  const sections = [
    { title: "Content", items: [
      { label: "Programmes", description: "Course programmes and modules", path: "/admin/programmes", icon: BookOpen },
      { label: "Videos", description: "Video library synced from Vimeo", path: "/admin/videos", icon: CirclePlay },
      { label: "Resources", description: "Downloadable files and documents", path: "/admin/resources", icon: FileText },
      { label: "Live Sessions", description: "Live sessions synced from Arlo", path: "/admin/live_sessions", icon: Video },
    ]},
    { title: "People", items: [
      { label: "Members", description: "Platform members and memberships", path: "/admin/members", icon: Users },
      { label: "Contributors", description: "Presenters and content authors", path: "/admin/contributors", icon: UserCircle },
      { label: "Admin Users", description: "Admin accounts and permissions", path: "/admin/users", icon: Shield },
    ]},
    { title: "Other", items: [
      { label: "Site Pages", description: "Manage site pages like T&Cs and policies", path: "/admin/site_pages", icon: NotebookPen },
      { label: "Invoice Requests", description: "Review and approve invoice requests", path: "/admin/invoice_requests", icon: Receipt },
      { label: "Tags", description: "Content tags and categories", path: "/admin/tags", icon: Tags },
      { label: "Feedback", description: "Member feedback and responses", path: "/admin/feedback", icon: MessageSquare },
    ]},
  ]
</script>

<Page.Layout title="Admin">

  <Page.Navigation title="Admin" Icon={LayoutDashboard} />

  <Page.Titles title="Admin Dashboard" subtitle="Manage all aspects of the Altruist Wellbeing platform" />

  <Page.Content>
    <div class="flex flex-col gap-8">
      {#each sections as section}
        <div>
          <h3 class="text-sm font-medium text-gray-400 uppercase tracking-wide mb-3">{section.title}</h3>
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {#each section.items as item}
              <button onclick={() => router.visit(item.path)}
                class="flex items-center gap-4 p-4 bg-white border border-gray-200 rounded-lg hover:border-gray-300 hover:shadow-sm transition-all text-left cursor-pointer">
                <div class="flex items-center justify-center w-10 h-10 bg-gray-50 rounded-lg shrink-0">
                  <svelte:component this={item.icon} size={20} class="text-gray-500" />
                </div>
                <div class="flex-1 min-w-0">
                  <p class="text-sm font-medium text-gray-800">{item.label}</p>
                  <p class="text-xs text-gray-400 mt-0.5">{item.description}</p>
                </div>
                <ChevronRight size={16} class="text-gray-300 shrink-0" />
              </button>
            {/each}
          </div>
        </div>
      {/each}
    </div>
  </Page.Content>

</Page.Layout>
